import { EntityTagFilter } from '@backstage/plugin-catalog-react';
import { EntityAutocompletePicker } from './EntityAutocompletePicker/EntityAutocompletePicker';

export type EntityTagPickerProps = {
  showCounts?: boolean;
};

export const EntityTagPicker = (props: EntityTagPickerProps) => {
  return (
    <EntityAutocompletePicker
      label="Tags"
      path="metadata.tags"
      Filter={EntityTagFilter}
      showCounts={props.showCounts}
    />
  );
};
